
import {
  Component, Prop, Vue, Emit,
} from 'nuxt-property-decorator'
import BaseSearchInput from '../base/form/BaseSearchInput.vue'
import { globalLabelAsString } from '../../shared/general/services/StoreService'

@Component({
  name: 'ServiceSearch',
  components: { BaseSearchInput },
})
export default class ServiceSearch extends Vue {
  @Prop({ default: '' }) searchTerm! : string

  @Prop({ default: false }) resetButtonVisible! : boolean

  @Prop({ required: true }) showSearchButtonLoadingAnimation! : boolean

  @Prop({ required: true }) searchActionTriggered! : Function

  @Prop({ required: true }) resetButtonClicked! : Function

  private get resetSearchLabel () : string {
    return globalLabelAsString('reset_search_label')
  }

  private get clearLabel () : string {
    return globalLabelAsString('clear_all_label')
  }

  @Emit('input-value-changed')
  private inputValueChanged (value : string) : string {
    return value
  }
}
